"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _ascendingComparator = _interopRequireDefault(require("./ascendingComparator"));

var _isArray = _interopRequireDefault(require("../object/isArray"));

var _isNil = _interopRequireDefault(require("../object/isNil"));

var _isEmpty = _interopRequireDefault(require("../array/isEmpty"));

/**
 * Sorts the values of an array by the specified properties.
 * Ties will resolve in the order they appear in the array.
 * Mulitple keys can be supplied to further sort ties.
 * @param {array} array of values to sort
 * @param {SortProperty[]} properties - a list of properties to sort the data by.
 * @returns {array} a copy of the array, sorted
 */
var sortByProperties = function sortByProperties(array, properties) {
  if (!(0, _isArray["default"])(array)) {
    // todo(): throw error
    return array;
  }

  if ((0, _isEmpty["default"])(array)) {
    return []; // Returns a new array since sort below does not mutate original array.
  }

  return (0, _toConsumableArray2["default"])(array).sort(function (a, b) {
    var comparison = 0;
    properties.forEach(function (property) {
      var _property$comparator = property.comparator,
          comparator = _property$comparator === void 0 ? _ascendingComparator["default"] : _property$comparator,
          key = property.key;

      if ((0, _isNil["default"])(a[key]) || (0, _isNil["default"])(b[key])) {
        // todo(): throw error
        return;
      }

      comparison = comparison || comparator(a[key], b[key]);
    });
    return comparison;
  });
};

var _default = sortByProperties;
exports["default"] = _default;